/** Read ops-* localStorage keys with one-time migration from legacy dio-* keys. */
export function getOpsStorage(key, legacyKey = null) {
  const opsKey = key.startsWith('ops-') ? key : `ops-${key}`;
  const legacy = legacyKey || opsKey.replace(/^ops-/, 'dio-');
  try {
    const current = localStorage.getItem(opsKey);
    if (current != null) return current;
    const old = localStorage.getItem(legacy);
    if (old != null) {
      localStorage.setItem(opsKey, old);
      return old;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function setOpsStorage(key, value) {
  const opsKey = key.startsWith('ops-') ? key : `ops-${key}`;
  try {
    localStorage.setItem(opsKey, value);
  } catch {
    /* ignore */
  }
}
